import { Grid } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import { Show } from '../../../../../../../react-commons/components/control-flow/Show';
import type { FormNames } from '../../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { WorkflowRepresentationType } from '../../../../../resource/enumerations/WorkflowRepresentationType';
import {
    WorkflowRepresentationPropertyValidation,
    type WorkflowRepresentationResource,
} from '../../../../../resource/resources/artifacts/use_case/representation/workflowRepresentationResource';
import { PropertyInputs } from '../../../../reusable-components/base/property-bases/PropertyInputs';
import type { PropertyValidationInformation } from '../../../../util/PropertyValidationInformation';

export const WorkflowRepresentationContent = ({
    id,
    form,
    formNames,
    readOnly,
    displayedInOverview,
}: {
    id?: string;
    form: UseFormReturn<WorkflowRepresentationResource>;
    formNames: FormNames<WorkflowRepresentationResource>;
    readOnly: boolean;
    displayedInOverview?: boolean;
}) => {
    const getPropertyValidationInformation = (
        propertyIdentifier: WorkflowRepresentationPropertyValidation
    ): PropertyValidationInformation => ({
        resourceId: id,
        resourceType: ResourceType.WORKFLOW_REPRESENTATION,
        propertyIdentifier,
    });

    return (
        <Grid>
            <Show when={!displayedInOverview}>
                <Grid.Col span={6}>
                    <PropertyInputs.Name
                        name={formNames.name}
                        control={form.control}
                        readOnly={readOnly}
                        propertyValidationInformation={getPropertyValidationInformation(
                            WorkflowRepresentationPropertyValidation.NAME
                        )}
                    />
                </Grid.Col>
            </Show>
            <Grid.Col span={6}>
                <PropertyInputs.Enum
                    name={formNames.type}
                    nullable={false}
                    control={form.control}
                    readOnly={Boolean(id)}
                    enumType={WorkflowRepresentationType}
                    propertyValidationInformation={getPropertyValidationInformation(
                        WorkflowRepresentationPropertyValidation.TYPE
                    )}
                />
            </Grid.Col>
            <Grid.Col span={12}>
                <PropertyInputs.MultilineString
                    name={formNames.description}
                    nullable={false}
                    control={form.control}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        WorkflowRepresentationPropertyValidation.DESCRIPTION
                    )}
                />
            </Grid.Col>
        </Grid>
    );
};
